import { useCallback } from 'react';

import { useLedgerSummaryByIdQuery } from '../data-access';
import { type WalletLedgerSummaryInfo } from '../models';

type InUseData = {
	bonusAndOnHold?: number | string;
	inUseBalanceData?: number | string;
	tradableBalance?: number | string;
};

/**
 * @returns An object of in-use, tradable and non-traable values from the ledger data.
 */
export const usePartnerWalletTokenSummarySection = (ledgerId: string) => {
	const walletLedgerSummaryInUseDetailsReducer = useCallback(
		(data: undefined | WalletLedgerSummaryInfo): InUseData => {
			return {
				bonusAndOnHold: data?.nonTradableBalance || 0,
				inUseBalanceData: data?.inUseBalance || 0,
				tradableBalance: data?.tradableBalance || 0
			};
		},
		[]
	);
	const {
		data: ledgerSummary,
		error,
		isLoading,
		refetch
	} = useLedgerSummaryByIdQuery(ledgerId, walletLedgerSummaryInUseDetailsReducer);
	const tokenSummary = ledgerSummary! || {};

	return { error, isLoading, refetch, tokenSummary };
};
